export default function () {
  this.isRemenberActive()
}



// WEBPACK FOOTER //
// ./src/app/auth/login/dweller/resources/mounted.js